module.exports = __webpack_public_path__ + "static/img/target-oxbridge-october-2019.a8dc3ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/target-oxbridge-october-2019.jpg
// module id = 41eN
// module chunks = 0